import { ParalegalPartTimeThankYouUrl, BasketCartUrl } from "../directives/utilities/urls";

export default function paralegalPartTime() {
    return {
        isParalegalOther: false,
        isNotWorkforce: false,
        partTimeSchedule: [{ institution: '', major: '', graduationDate: '', degreeEarned: '' }],
        professionalReferences: [{ name: '', jobTitle: '', phone: '', email: '' }],
        paralegalOther: [],
        programType: "PARAL",
        message: '',
        isPartTimeSchedule: false,
        isPartTimeScheduleError: '',
        isProfessionalReferences: false,
        isProfessionalReferencesError: '',
        isParalegalOtherError: '',
        isParalegalJobOptions: false,
        isParalegalJobOptionsError: '',

        isPartTimeScheduleInstitution:[],
        isPartTimeScheduleInstitutionError: [],
        isPartTimeScheduleMajor: [],
        isPartTimeScheduleMajorError: [],
        isPartTimeScheduleGraduationDate: [],
        isPartTimeScheduleGraduationDateError: [],
        isPartTimeScheduleDegreeEarned: [],
        isPartTimeScheduleDegreeEarnedError: [],

        isProfessionalReferencesName: [],
        isProfessionalReferencesNameError: [],
        isProfessionalReferencesJobTitle: [],
        isProfessionalReferencesJobTitleError: [],
        isProfessionalReferencesPhone: [],
        isProfessionalReferencesPhoneError:[],
        isProfessionalReferencesEmail: [],
        isProfessionalReferencesEmailError: [],

        isParalegalOtherJobTitle: false,
        isParalegalOtherJobTitleError: '',
        isParalegalOtherCompanyName: false,
        isParalegalOtherCompanyNameError: '',
        isParalegalOtherCompanyLocation: false,
        isParalegalOtherCompanyLocationError: '',
        isFormValid: false,
        isDateValid: false,
        isPartTimeScheduleLastRowAdded:true,
        resetData() {

            this.message = "";
        },
       
        paralegalOtherClick() {
            this.paralegalOther= [];
            this.isParalegalOther = true;
            this.isNotWorkforce = false;
            this.paralegalOther.push({ jobTitle: '', companyName: '', companyLocation: '' });
            this.isParalegalJobOptions = true;
            this.isParalegalJobOptionsError = "";
            this.message = "";
        },
        notWorkforceClick() {
            this.isNotWorkforce = true;
            this.isParalegalOther = false;
            this.paralegalOther = [];
            this.isParalegalJobOptions = true;
            this.isParalegalJobOptionsError = "";
            this.message = "";
        },
        addRow() {
            this.isPartTimeScheduleLastRowAdded = true;
            this.isPartTimeScheduleInstitution = [];
            this.isPartTimeScheduleInstitutionError = [];
            this.isPartTimeScheduleMajor = [];
            this.isPartTimeScheduleMajorError = [];
            this.isPartTimeScheduleGraduationDate = [];
            this.isPartTimeScheduleGraduationDateError = [];
            this.isPartTimeScheduleDegreeEarned = [];
            this.isPartTimeScheduleDegreeEarnedError = [];
            if (this.partTimeSchedule.length > 0) {
                for (let i = 0; i < this.partTimeSchedule.length; i++) {
                    if (this.partTimeSchedule[i].institution === '') {

                        this.isPartTimeScheduleInstitution.push("true");
                        this.isPartTimeScheduleInstitutionError.push("Please provide name of institution providing transcript");
                        this.isPartTimeScheduleLastRowAdded = false;
                        this.isFormValid = false;
                    }
                    else {
                        this.isPartTimeScheduleInstitution.push("false");
                        this.isPartTimeScheduleInstitutionError.push("");
                    }
                    if (this.partTimeSchedule[i].major === '') {

                        this.isPartTimeScheduleMajor.push("true");
                        this.isPartTimeScheduleMajorError.push("Please provide your major or N/A");
                        this.isPartTimeScheduleLastRowAdded = false;
                        this.isFormValid = false;
                    }
                    else {
                        this.isPartTimeScheduleMajor.push("false");
                        this.isPartTimeScheduleMajorError.push("");
                    }
                    if (this.partTimeSchedule[i].graduationDate === '') {

                        this.isPartTimeScheduleGraduationDate.push("true");
                        this.isPartTimeScheduleGraduationDateError.push("Please provide your graduation date");
                        this.isPartTimeScheduleLastRowAdded = false;
                        this.isFormValid = false;
                    }
                    //else if (!this.isValidDate(this.partTimeSchedule[i].graduationDate)) {
                    //    this.isPartTimeScheduleGraduationDate.push("true");
                    //    this.isPartTimeScheduleGraduationDateError.push("Please provide valid date in MM/DD/YYYY format");
                    //    this.isPartTimeScheduleLastRowAdded = false;
                    //    this.isFormValid = false;
                    //}
                    else {
                        this.isPartTimeScheduleGraduationDate.push("false");
                        this.isPartTimeScheduleGraduationDateError.push("");

                    }
                    if (this.partTimeSchedule[i].degreeEarned === '') {

                        this.isPartTimeScheduleDegreeEarned.push("true");
                        this.isPartTimeScheduleDegreeEarnedError.push("Please provide degree earned or N/A");
                        this.isPartTimeScheduleLastRowAdded = false;
                        this.isFormValid = false;
                    }
                    else {
                        this.isPartTimeScheduleDegreeEarned.push("false");
                        this.isPartTimeScheduleDegreeEarnedError.push("");

                    }
                }
                
            }
                if (this.isPartTimeScheduleLastRowAdded)
                {
                    this.partTimeSchedule.push({ institution: '', major: '', graduationDate: '', degreeEarned: '' });
                }
           
        },
        removeRow(index) {
            this.partTimeSchedule.splice(index, 1);
        },
        isValidDate(dateValue) {
            const date = new Date(dateValue);
            const month = date.getMonth() + 1; // Month is zero-based, so add 1
            const day = date.getDate();
            const year = date.getFullYear();
            var newDate= `${month}/${day}/${year}`;
            const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/\d{4}$/;
            return dateRegex.test(newDate);
        },
        isValidEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        isValidPhone(phone) {
            const regex = /^\(\d{3}\) ?\d{3}-\d{4}$/; 
            return regex.test(phone);
        },
        sendParalegalFormData() {
            this.isFormValid = true;
            this.isPartTimeScheduleInstitution = [];
            this.isPartTimeScheduleInstitutionError = [];
            this.isPartTimeScheduleMajor = [];
            this.isPartTimeScheduleMajorError = [];
            this.isPartTimeScheduleGraduationDate = [];
            this.isPartTimeScheduleGraduationDateError = [];
            this.isPartTimeScheduleDegreeEarned = [];
            this.isPartTimeScheduleDegreeEarnedError = [];

            if (this.partTimeSchedule.length > 0) {
                for (let i = 0; i < this.partTimeSchedule.length; i++) {
                    if (this.partTimeSchedule[i].institution === '') {

                        this.isPartTimeScheduleInstitution.push("true");
                        this.isPartTimeScheduleInstitutionError.push("Please provide name of institution providing transcript");
                        this.isFormValid = false;
                    }
                    else {
                        this.isPartTimeScheduleInstitution.push("false");
                        this.isPartTimeScheduleInstitutionError.push("");
                       /* this.isFormValid = true;*/
                    }
                    if (this.partTimeSchedule[i].major === '') {

                        this.isPartTimeScheduleMajor.push("true");
                        this.isPartTimeScheduleMajorError.push("Please provide your major or N/A");
                        this.isFormValid = false;
                    }
                    else {
                        this.isPartTimeScheduleMajor.push("false");
                        this.isPartTimeScheduleMajorError.push("");
                      /*  this.isFormValid = true;*/
                    }
                    if (this.partTimeSchedule[i].graduationDate === '') {

                        this.isPartTimeScheduleGraduationDate.push("true");
                        this.isPartTimeScheduleGraduationDateError.push("Please provide your graduation date");
                        this.isFormValid = false;
                    }
                    //else if (!this.isValidDate(this.partTimeSchedule[i].graduationDate))
                    //{
                    //    this.isPartTimeScheduleGraduationDate.push("true");
                    //    this.isPartTimeScheduleGraduationDateError.push("Please provide valid date in MM/DD/YYYY format");
                    //    this.isFormValid = false;
                    //}
                    else
                    {
                        this.isPartTimeScheduleGraduationDate.push("false");
                        this.isPartTimeScheduleGraduationDateError.push("");
                        //this.isFormValid = true;
                    }
                    if (this.partTimeSchedule[i].degreeEarned === '') {

                        this.isPartTimeScheduleDegreeEarned.push("true");
                        this.isPartTimeScheduleDegreeEarnedError.push("Please provide degree earned or N/A");
                        this.isFormValid = false;
                    }
                    else {
                        this.isPartTimeScheduleDegreeEarned.push("false");
                        this.isPartTimeScheduleDegreeEarnedError.push("");
                        //this.isFormValid = true;
                    }

                }
               
            }

            this.isProfessionalReferencesName = [];
            this.isProfessionalReferencesNameError = [];
            this.isProfessionalReferencesJobTitle = [];
            this.isProfessionalReferencesJobTitleError = [];
            this.isProfessionalReferencesPhone = [];
            this.isProfessionalReferencesPhoneError = [];
            this.isProfessionalReferencesEmail = [];
            this.isProfessionalReferencesEmailError = [];

            if (this.professionalReferences.length >= 0) {
                for (let j = 0; j < this.professionalReferences.length; j++) {
                    if (this.professionalReferences[j].name === '') {

                        this.isProfessionalReferencesName.push("true");
                        this.isProfessionalReferencesNameError.push("Please provide full name of your reference.");
                        this.isFormValid = false;
                    }
                    else {
                        this.isProfessionalReferencesName.push("false");
                        this.isProfessionalReferencesNameError.push("");
                        //this.isFormValid = true;
                    }
                    if (this.professionalReferences[j].jobTitle === '') {

                        this.isProfessionalReferencesJobTitle.push("true");
                        this.isProfessionalReferencesJobTitleError.push("Please provide your reference's job title/description.");
                        this.isFormValid = false;
                    }
                    else {
                        this.isProfessionalReferencesJobTitle.push("false");
                        this.isProfessionalReferencesJobTitleError.push("");
                        //this.isFormValid = true;
                    }
                    if (this.professionalReferences[j].phone === '') {

                        this.isProfessionalReferencesPhone.push("true");
                        this.isProfessionalReferencesPhoneError.push("Please provide your reference's phone number.");
                        this.isFormValid = false;
                    }
                    //else if (!this.isValidPhone(this.professionalReferences[j].phone)) {
                    //    this.isProfessionalReferencesPhone.push("true");
                    //    this.isProfessionalReferencesPhoneError.push("Please provide valid phone number.");
                    //    this.isFormValid = false;
                    //}
                    else {
                        this.isProfessionalReferencesPhone.push("false");
                        this.isProfessionalReferencesPhoneError.push("");
                        //this.isFormValid = true;
                    }
                    if (this.professionalReferences[j].email === '') {

                        this.isProfessionalReferencesEmail.push("true");
                        this.isProfessionalReferencesEmailError.push("Please provide your reference's email address.");
                        this.isFormValid = false;
                    }
                    else if (!this.isValidEmail(this.professionalReferences[j].email))
                    {
                        this.isProfessionalReferencesEmail.push("true");
                        this.isProfessionalReferencesEmailError.push("Please provide valid email address.");
                        this.isFormValid = false;
                    }
                    else
                    {
                        this.isProfessionalReferencesEmail.push("false");
                        this.isProfessionalReferencesEmailError.push("");
                        //this.isFormValid = true;
                    }

                }

            }
                    
            if (!this.isParalegalOther && !this.isNotWorkforce) {
                this.isParalegalJobOptions = false;
                this.isParalegalJobOptionsError = "Please select one option from Current Job Position.";
                this.isFormValid = false;
            }
            else {
                this.isParalegalJobOptions = true;
                this.isParalegalJobOptionsError = "";
                //this.isFormValid = true;
            }
            if (this.isParalegalOther && this.paralegalOther[0].jobTitle === '')
            {
               
                this.isParalegalOtherJobTitle=true;
                this.isParalegalOtherJobTitleError = "Please provide title of your job position."
                this.isFormValid = false;
            }
            else {
                this.isParalegalOtherJobTitle = false;
                this.isParalegalOtherJobTitleError = "";
                //this.isFormValid = true;
            }
            if (this.isParalegalOther && this.paralegalOther[0].companyName === '') {

                this.isParalegalOtherCompanyName = true;
                this.isParalegalOtherCompanyNameError = "Please provide company name you held the job position.";
                this.isFormValid = false;
            }
            else {
                this.isParalegalOtherCompanyName = false;
                this.isParalegalOtherCompanyNameError = "";
                //this.isFormValid = true;
            }
            if (this.isParalegalOther && this.paralegalOther[0].companyLocation === '') {

                this.isParalegalOtherCompanyLocation = true;
                this.isParalegalOtherCompanyLocationError = "Please provide company location as City, State you held the job position.";
                this.isFormValid = false;
            }
            else {
                this.isParalegalOtherCompanyLocation = false;
                this.isParalegalOtherCompanyLocationError = "";
                //this.isFormValid = true;
            }
               
           
            if (this.isFormValid) {
                fetch('/api/basket/SendParalegalFormData', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        partTimeSchedule: this.partTimeSchedule,
                        professionalReferences: this.professionalReferences,
                        isParalegalOther: this.isParalegalOther,
                        isNotWorkforce: this.isNotWorkforce,
                        paralegalOther: this.paralegalOther,
                    })
                })
                    .then(response => {
                        if (response.ok) {
                            return response.json()
                        }
                    }).then(response => {

                        if (response.isSuccess) {
                            fetch('/api/Basket/declare-candidacy', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    SessionId: "",
                                    CandidacyOption: this.programType,
                                })
                            })
                                .then(response => {
                                    if (response.ok) {
                                        return response.json()
                                    }
                                }).then(response => {

                                    if (response.isSuccess) {
                                        this.message ="";
                                        
                                            window.location.href = BasketCartUrl;
                                    } else {
                                        this.message = response.messages.length > 0 ? response.messages[0] : "Something went wrong";

                                    }

                                });
                           // window.location.href = ParalegalPartTimeThankYouUrl;
                        } else {
                            this.message = "Something went wrong";
                        }

                    });
                   
            }
        },

        init() {
            this.professionalReferences.push({ name: '', jobTitle: '', phone: '', email: '' });
            const urlParams = new URLSearchParams(window.location.search);
            this.programType = urlParams.get('id')
            
        }
    }
}